import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch, useSelector } from 'react-redux';
import { salesPageAsyncActions, salesPageSelectors } from '@/Pages/Sales/services';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { useCallback } from 'react';
import { AutomaticallyGeneratedDocumentType } from '@/Enums/AutomaticallyGeneratedDocumentType';
import { printService } from '@/Electron';
import { DocumentTemplateRow } from '@/Types';
import { documentPrintModalActions, DocumentPrintStep } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { PrintUnionDocumentRequest } from '@/Api/DocumentTemplates/Requests/PrintUnionDocumentRequest';

export const useDocumentPrintModalActions = () => {
  const dispatch: AppDispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const selectedSalesIds = useSelector(salesPageSelectors.selectedSalesIds);
  const documentType = useSelector(documentPrintModalSelectors.documentType);
  const documentTemplates = useSelector(documentPrintModalSelectors.documentTemplates);
  const selectedTemplate = useSelector(documentPrintModalSelectors.selectedDocumentTemplate);

  const printOrderDocuments = useCallback(() => {
    if (selectedTemplate && selectedSalesIds?.length > 0) {
      const request: PrintUnionDocumentRequest = {
        orderIds: selectedSalesIds,
        copyCount: selectedTemplate.countCopy,
        isSortWhenPrinting: selectedTemplate.isSortWhenPrinting,
        automaticallyGeneratedDocumentType: AutomaticallyGeneratedDocumentType.DPRNT,
      };

      printService.printHandler(request, selectedTemplate.guid, () => {
        dispatch(salesPageAsyncActions.getOrdersByIds(selectedSalesIds));
      });
    }
  }, [selectedTemplate]);

  const printDocuments = (callback: (template: DocumentTemplateRow) => void) => {
    if (!selectedSale) return;

    const documentTemplate = documentTemplates.find((item) => {
      return item.numberGenerationType == documentType;
    });

    if (!documentTemplate) {
      dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.TemplateNotExists));
      return;
    }

    callback(documentTemplate);
  };

  return {
    printOrderDocuments,
    printDocuments,
  };
};
